import clsx from 'clsx'

type HeadingProps = { level?: 1 | 2 | 3 | 4 | 5 | 6 } & React.ComponentPropsWithoutRef<
  'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
>

// Titles/headlines: Poppins Bold in Collectia Blue (#15253D). See DESIGN_GUIDELINES §3.
export function Heading({ className, level = 1, ...props }: HeadingProps) {
  let Element: `h${typeof level}` = `h${level}`

  return (
    <Element
      {...props}
      className={clsx(className, 'font-heading text-2xl/8 font-bold text-text-strong sm:text-xl/8')}
    />
  )
}

// Subheadings: Open Sans Bold in Collectia Blue (#15253D).
export function Subheading({ className, level = 2, ...props }: HeadingProps) {
  let Element: `h${typeof level}` = `h${level}`

  return (
    <Element
      {...props}
      className={clsx(className, 'font-body text-base/7 font-bold text-text-strong sm:text-sm/6')}
    />
  )
}
